import Cookies from "js-cookie";
import posthog from "posthog-js";
import { LC_KEYS } from "../utils/constants";

/**
 * Clears the core auth session data and redirects to login.
 * Used when a 401 Unauthorized response is received from the API.
 */
export const clearSessionAndRedirect = (): void => {
  // Clear core auth keys only
  localStorage.removeItem("token");
  localStorage.removeItem("userInfo");
  Object.values(LC_KEYS).forEach((key) => {
    localStorage.removeItem(key);
  });

  // Clear all cookies
  const allCookies = Cookies.get();
  for (const cookieName of Object.keys(allCookies)) {
    Cookies.remove(cookieName);
  }

  // Reset PostHog tracking
  posthog.reset();

  // Redirect to login page
  window.location.href = "/login";
};
